exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display: -ms-grid;\n  display: grid;\n  padding: var(--padding);\n  gap: var(--padding); }\n  :host > * {\n    margin: 0;\n    padding: 0; }\n  :host ul {\n    list-style-type: none;\n    display: -ms-grid;\n    display: grid; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/dashboard/dashboard.component.scss
// module id = ../../../../../src/app/dashboard/dashboard.component.scss
// module chunks = main